<template>
  <div>
    <v-card width="100%" v-if="current">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-4 col-sm-1">
              <div class="d-flex align-center">
                <v-text-field
                  label="Cliente"
                  v-model="current.clientName"
                  outlined
                  dense
                  disabled
                  hide-details
                >
                </v-text-field>
                <v-btn icon class="ml-1" @click="showClient = !showClient">
                  <v-icon>{{ showClient ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field
                label="Plano"
                v-model="current.planName"
                outlined
                dense
                disabled
                hide-details
              >
              </v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-select
                label="Status"
                v-model="current.status"
                :items="status"
                item-text="name"
                item-value="id"
                outlined
                dense
                disabled
                hide-details
              ></v-select>
            </div>
            <div class="col-md-9 col-sm-1">
              <v-text-field
                label="Contato"
                v-model="current.contact"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Telefone"
                v-model="current.phone"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
          </div>

          <v-expand-transition>
            <div class="row" v-show="showClient" v-if="clientDetails">
              <div class="col-md-12 col-sm-1">
                <v-sheet elevation="5" class="pa-4">
                  <div class="d-flex align-center mb-2">
                    <v-icon left>mdi-account-box</v-icon>
                    <span class="subtitle-1">Dados do Cliente</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      small
                      text
                      color="primary"
                      :href="$router.resolve(`/client/${current.clientId}`).href"
                      target="_blank"
                    >
                      <v-icon left small>mdi-open-in-new</v-icon>Abrir cadastro
                    </v-btn>
                  </div>
                  <div class="row">
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CPF/CNPJ"
                        v-model="clientDetails.register"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Telefone"
                        v-model="clientDetails.telephone"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Celular"
                        v-model="clientDetails.cellphone"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Email"
                        v-model="clientDetails.email"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Logradouro"
                        v-model="clientDetails.address"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Número"
                        v-model="clientDetails.addressNumber"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Complemento"
                        v-model="clientDetails.addressExtra"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Bairro"
                        v-model="clientDetails.addressNeighborhood"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-4 col-sm-1">
                      <v-text-field
                        label="Cidade"
                        v-model="clientDetails.city"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Estado"
                        v-model="clientDetails.province"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="País"
                        v-model="clientDetails.country"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CEP"
                        v-model="clientDetails.zipcode"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                  </div>
                </v-sheet>
              </div>
            </div>
          </v-expand-transition>

          <div class="row">
            <div class="col-md-6 col-sm-1" v-if="events">
              <v-sheet elevation="5" class="pa-2">
                Eventos:
                <v-chip
                  class="ma-2"
                  color="error"
                  text-color="white"
                  @click="dialogEvents(11)">
                  <v-avatar left class="error darken-4">{{  computedBlockCount }}</v-avatar>Bloqueios
                </v-chip>
                <v-chip
                  class="ma-2"
                  color="primary"
                  text-color="white"
                  close
                  close-icon="mdi-plus-circle"
                  @click:close="dialogCreateEvent(23)"
                  @click="dialogEvents(23)">
                  <v-avatar left class="primary darken-4">{{ computedPonLosCount }}</v-avatar>PON
                </v-chip>
              </v-sheet>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-sheet elevation="1" class="pa-2">
                Tags:
                <v-chip
                  v-for="item in tags"
                  :key="item.name"
                  close
                  @click:close="tagRemove(item.name)"
                  class="ma-2"
                >
                  {{ item.name }}
                </v-chip>
                <v-chip @click="tagAdd()">+</v-chip>
              </v-sheet>
            </div>
          </div>

          <v-row><v-col>
          <v-sheet elevation="5" class="pa-2" height="300">
          <v-tabs v-model="tab" grow class="mt-2">
            <v-tab key="drop"> Drop </v-tab>
            <v-tab key="dados"> Dados </v-tab>
            <v-tab key="financeiro"> Financeiro </v-tab>
            <v-tab key="suporte"> Suporte </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item key="drop">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Logradouro"
                        v-model="current.address"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Número"
                        v-model="current.addressNumber"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Complemento"
                        v-model="current.addressExtra"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Bairro"
                        v-model="current.addressNeighborhood"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Cidade"
                        v-model="current.city"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Estado"
                        v-model="current.province"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="País"
                        v-model="current.country"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CEP"
                        v-model="current.zipcode"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="dados">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Serial"
                        v-model="current.serial"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-select
                        label="NMS"
                        v-model="current.nms"
                        :items="nms"
                        item-text="name"
                        item-value="id"
                        outlined
                        dense
                        disabled
                      ></v-select>
                    </div>
                  </div>
                  <v-btn color="success" @click="loadPowers()">Histórico de potência</v-btn>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="financeiro">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Mensalidade"
                        v-model="current.price"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Vencimento"
                        v-model="current.expires"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Taxa de Instalação"
                        v-model="current.setupPrice"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Parcelas da Instalação"
                        v-model="current.setupSplit"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        v-model="computedSetup"
                        label="Dia da Instalação"
                        readonly
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="suporte">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-12 col-sm-1">
                      <v-textarea
                        label="Observações"
                        v-model="current.obs"
                        outlined
                        dense
                        readonly
                        auto-grow
                      ></v-textarea>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          </v-sheet></v-col></v-row>

        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn
            v-if="current.status > 0 && current.status < 4"
            color="success"
            @click="dialogStatusUnblock()"
            class="ma-2"
            >Desbloquear</v-btn>
          <v-btn
            v-if="current.status == 0"
            color="error"
            @click="dialogStatusBlock()"
            class="ma-2"
            >Bloquear</v-btn>
          <v-btn
            v-if="current.status < 4"
            color="secondary"
            @click="dialogStatusCancel()"
            class="ma-2"
            >Cancelar</v-btn>
          <v-btn 
            v-if="current.status == 0" 
            @click="dialogClient()" 
            color="primary" 
            class="ma-2"
            >Mudança de Titularidade</v-btn>
          <v-btn 
            v-if="current.status == 0" 
            @click="dialogPlan()" 
            color="primary" 
            class="ma-2"
            >Mudança de Plano</v-btn>
          <v-btn 
            v-if="current.status == 0" 
            @click="dialogSerial()" 
            color="primary" 
            class="ma-2"
            >Trocar ONU</v-btn>
          <v-btn 
            v-if="current.status == 0" 
            @click="dialogAddress()" 
            color="primary" 
            class="ma-2"
            >Mudança de Endereço</v-btn>
          <v-btn 
            v-if="current.status == 0" 
            @click="dialogObs()" 
            color="primary" 
            class="ma-2"
            >Alterar observações</v-btn>
          <v-btn 
            v-if="current.status == 0" 
            @click="dialogContact()" 
            color="primary" 
            class="ma-2"
            >Alterar contato</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_status_block" width="300">
      <v-card>
        <v-card-title>Bloqueio de Lastmile</v-card-title>
        <v-card-text>
          <v-select
            label="Status"
            v-model="changed.status"
            :items="statusBlocks"
            item-text="name"
            item-value="id"
            outlined
            dense
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="putStatusBlock()">Bloquear</v-btn>
          <v-btn color="default" @click="dialog_status_block = false"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_status_unblock" width="300">
      <v-card>
        <v-card-title>Desbloqueio de Lastmile</v-card-title>
        <v-card-text>
          Tem certeza que deseja desbloquear o serviço de Lastmile?
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putStatusUnblock()">Desbloquear</v-btn>
          <v-btn color="default" @click="dialog_status_unblock = false"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_status_cancel" width="400">
      <v-card>
        <v-card-title>Cancelamento de Lastmile</v-card-title>
        <v-card-text>
          Tem certeza que deseja CANCELAR o serviço de lastmile?<br /><br />
          <b class="error pa-2"
            >Atenção: esse processo NÃO pode ser desfeito!</b
          >
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="putStatusCancel()"
            >Cancelar lastmile</v-btn
          >
          <v-btn color="default" @click="dialog_status_cancel = false"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_address" max-width="600px">
      <v-card>
        <v-card-title>Alterar Endereço do DROP</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Logradouro"
              v-model="changed.address"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Número"
              v-model="changed.addressNumber"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Complemento"
              v-model="changed.addressExtra"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Bairro"
              v-model="changed.addressNeighborhood"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Cidade"
              v-model="changed.city"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Estado"
              v-model="changed.province"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Pais"
              v-model="changed.country"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="CEP"
              v-model="changed.zipcode"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putAddress()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_address = false"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_obs" max-width="1000px">
      <v-card>
        <v-card-title>Alterar Observação</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-textarea
              label="Observações"
              v-model="changed.obs"
              outlined
              dense
              rows="15"
            ></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putObs()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_obs = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_serial" max-width="500px">
      <v-card>
        <v-card-title>Trocar ONU</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Serial"
              v-model="changed.serial"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-select
              label="NMS"
              v-model="changed.nms"
              :items="nms"
              item-text="name"
              item-value="id"
              outlined
              dense
            ></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putSerial()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_serial = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_client" max-width="500px">
      <v-card>
        <v-card-title>Mudança de Titular</v-card-title>
        <v-card-text>
          <v-autocomplete
            label="Cliente"
            v-model="changed.clientId"
            :search-input.sync="searchClient"
            :items="clients"
            item-text="name"
            item-value="id"
            outlined
            dense
            @change="changeClient"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putClient()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_client = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_plan" max-width="500px">
      <v-card>
        <v-card-title>Mudança de Plano</v-card-title>
        <v-card-text>
          <v-autocomplete
            label="Plano"
            v-model="changed.planId"
            :search-input.sync="searchPlan"
            :items="plans"
            item-text="name"
            item-value="id"
            outlined
            dense
            @change="changePlan"
          ></v-autocomplete>
          <v-text-field
              label="Mensalidade"
              v-model="changed.price"
              outlined
              dense
            ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putPlan()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_plan = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_contact" max-width="500px">
      <v-card>
        <v-card-title>Alterar Contato</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Contato"
              v-model="changed.contact"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Telefone"
              v-model="changed.phone"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putContact()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_contact = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <power-history-dialog v-model="dialog_powers" :powers="powers"></power-history-dialog>

        <v-dialog v-model="dialog_events" width="40%">
      <v-card>
        <v-card-title>Histórico de Eventos</v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th>Horário</th>
                <th>Tipo</th>
                <th>Comentário</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in eventsFiltered" :key="item.id">
                <td>{{ item.time | formatDate }} {{ item.time | formatTime }}</td>
                <td>{{ item.entityEventType | formatEventType }}</td>
                <td>{{ item.data }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" @click="dialog_events = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_event_create" max-width="500px">
      <v-card>
        <v-card-title>Novo evento</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-select
              label="Tipo de Evento"
              v-model="currentEvent.entityEventType"
              :items="eventType"
              item-value="id"
              item-text="value"
              outlined
              dense
              readonly
            ></v-select>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-textarea
              label="Comentário"
              v-model="currentEvent.data"
              outlined
              dense
            ></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="postEvent()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_event_create = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" timeout="3000" color="success">
      Salvo com sucesso!
    </v-snackbar>

  </div>
</template>

<script>
import api from "../../api/index.js";
import PowerHistoryDialog from "../../components/PowerHistoryDialog.vue";
export default {
  components: { PowerHistoryDialog },
  data: () => ({
    current: null,
    clientDetails: null,
    showClient: false,
    currentEvent: {},
    events: [],
    eventType: [
      {id: 11, value: "Bloqueio"},
      {id: 12, value: "Desbloqueio"},
      {id: 13, value: "Cancelamento"},
      {id: 23, value: "PON"}
    ],
    eventsFiltered: [],
    powers: [],
    changed: {
      setup: null,
    },
    tab: null,
    snackbar: false,
    clients: [],
    searchClient: null,
    plans: [],
    searchPlan: null,
    nms: [],
    status: [
      { id: 0, name: "Habilitado" },
      { id: 1, name: "Bloqueado administrador" },
      { id: 2, name: "Bloqueado cliente" },
      { id: 3, name: "Bloqueado pagamento" },
      { id: 4, name: "Cancelado" },
    ],
    statusBlocks: [
      { id: 1, name: "Bloqueado administrador" },
      { id: 2, name: "Bloqueado cliente" },
      { id: 3, name: "Bloqueado pagamento" },
    ],
    dialog_loading: false,
    dialog_status_block: false,
    dialog_status_unblock: false,
    dialog_status_cancel: false,
    dialog_address: false,
    dialog_obs: false,
    dialog_serial: false,
    dialog_client: false,
    dialog_plan: false,
    dialog_contact: false,
    dialog_powers: false,
    dialog_events: false,
    dialog_event_create: false
  }),
  created: function () {
    this.load();
    this.loadNMS();
    this.loadEvents();
  },
  methods: {
    loadNMS: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/nms", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.nms = response.data;
        })
        .catch(function (error) {
          alert("Falha ao recuperar NMS!");
          console.log(error);
        });
    },
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/lastmile/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
          me.loadClient();
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
    loadClient: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/client/" + this.current.clientId, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.clientDetails = response.data;
        })
        .catch(function (error) {
          alert("Falha ao recuperar dados do cliente!");
          console.log(error);
        });
    },
    formatDate: function (date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    dialogPlan: function(){
      this.plans = [{id: this.current.planId, name: this.current.planName}];
      this.changed.planId = this.current.planId;
      this.changed.price = this.current.price;
      this.dialog_plan = true;
    },
    changePlan: function () {
      var planid = this.current.planId;
      for (var i = 0; i < this.plans.length; i++) {
        var plan = this.plans[i];
        if (plan.id == planid) {
          this.current.price = plan.price;
        }
      }
    },
    putPlan: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/lastmile/plan/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_plan = false;
          me.snackbar = true;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar plano!");
          console.log(error);
        });
    },
    dialogClient: function(){
      this.clients = [{id: this.current.clientId, name: this.current.clientName}];
      this.changed.clientId = this.current.clientId;
      this.dialog_client = true;
    },
    changeClient: function () {
      var clid = this.current.clientId;
      for (var i = 0; i < this.clients.length; i++) {
        var cli = this.clients[i];
        if (cli.id == clid) {
          /*
          this.current.address = cli.address;
          this.current.addressNumber = cli.addressNumber;
          this.current.addressExtra = cli.addressExtra;
          this.current.addressNeighborhood = cli.addressNeighborhood;
          this.current.city = cli.city;
          this.current.province = cli.province;
          this.current.country = cli.country;
          this.current.zipcode = cli.zipcode;
          */
          break;
        }
      }
    },
    putClient: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/lastmile/client/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_client = false;
          me.snackbar = true;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar plano!");
          console.log(error);
        });
    },
    tagRemove: function (tag) {
      var ntags = "";
      var tgs = this.current.tags.split(" ");
      for (var i = 0; i < tgs.length; i++) {
        if (tgs[i] != tag) {
          ntags += tgs[i] + " ";
        }
      }
      this.current.tags = ntags.trim();
      this.putTags();
    },
    tagAdd: function () {
      var tg = prompt("Digite a tag: ");
      if (tg) {
        this.current.tags = this.current.tags + " " + tg;
        this.putTags();
      }
    },
    putTags: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      this.changed.tags = this.current.tags;
      api
        .put("/lastmile/tags/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.snackbar = true;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar tags!");
          console.log(error);
        });
    },
    dialogStatusBlock: function () {
      this.changed.status = this.current.status;
      this.dialog_status_block = true;
    },
    putStatusBlock: function () {
      var me = this;
      var token = localStorage.getItem("token");
      if (this.changed.status < 1 || this.changed.status > 3) {
        alert("Selecione um status válido!");
        return;
      }
      me.dialog_loading = true;
      api
        .put("/lastmile/block/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_status_block = false;
          alert("Bloqueio feito com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao bloquear!");
          console.log(error);
        });
    },
    dialogStatusUnblock: function () {
      this.dialog_status_unblock = true;
    },
    putStatusUnblock: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/lastmile/unblock/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_status_unblock = false;
          alert("Desbloqueio de Lastmile feito com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao desbloquear Lastmile!");
          console.log(error);
        });
    },
    dialogStatusCancel: function () {
      this.dialog_status_cancel = true;
    },
    putStatusCancel: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/lastmile/cancel/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_status_cancel = false;
          alert("Lastmile CANCELADA com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao CANCELAR Lastmile!");
          console.log(error);
        });
    },
    dialogAddress: function () {
      this.changed.address = this.current.address;
      this.changed.addressNumber = this.current.addressNumber;
      this.changed.addressExtra = this.current.addressExtra;
      this.changed.addressNeighborhood = this.current.addressNeighborhood;
      this.changed.city = this.current.city;
      this.changed.province = this.current.province;
      this.changed.country = this.current.country;
      this.changed.zipcode = this.current.zipcode;
      this.dialog_address = true;
    },
    putAddress: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/lastmile/address/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_address = false;
          alert("Endereço alterado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar endereço!");
          console.log(error);
        });
    },
    dialogObs: function () {
      this.changed.obs = this.current.obs;
      this.dialog_obs = true;
    },
    putObs: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/lastmile/obs/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_obs = false;
          alert("Observação alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar observação!");
          console.log(error);
        });
    },
    dialogSerial: function () {
      this.changed.serial = this.current.serial;
      this.changed.nms = this.current.nms;
      this.dialog_serial = true;
    },
    putSerial: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/lastmile/serial/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_serial = false;
          alert("ONU alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar ONU!");
          console.log(error);
        });
    },
    dialogContact: function () {
      this.changed.contact = this.current.contact;
      this.changed.phone = this.current.phone;
      this.dialog_contact = true;
    },
    putContact: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/lastmile/contact/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_contact = false;
          alert("Contato alterado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar contato!");
          console.log(error);
        });
    },
    loadPowers: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/lastmile/powers/"+this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.powers = response.data;
          me.dialog_powers = true;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar potencias!");
          console.log(error);
        });
    },
    loadEvents: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/event/lastmile/"+this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.events = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar eventos!");
          console.log(error);
        });
    },
    dialogEvents: function(type){
      this.eventsFiltered = [];
      for(var i=0;i<this.events.length;i++){
        if(this.events[i].entityEventType==type){
          this.eventsFiltered.push(this.events[i]);
        }
      }
      this.dialog_events = true;
    },
    dialogCreateEvent: function(type){
      this.currentEvent = {
        entityEventType: type,
        data: ""
      };
      this.dialog_event_create = true;
    },
    postEvent: function(){
      var me = this;
      var token = localStorage.getItem("token");
      var evp = "";
      if(this.currentEvent.entityEventType==23){
        evp = "ponlos";
      }else{
        alert("Tipo de evento invalido!");
        return;
      }
      if(this.currentEvent.data===""){
        alert("Comentário não pode ser vazio!");
        return;
      }
      me.dialog_loading = true;
      api
        .post("/lastmile/"+evp+"/" + this.$route.params.id, this.currentEvent, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          me.dialog_loading = false;
          me.dialog_event_create = false;
          alert("Evento cadastrado com sucesso!");
          me.loadEvents();
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao cadastrar evento!");
          console.log(error);
        });
    }
  },
  computed: {
    computedBlockCount: function(){
      var count = 0;
      for(var i=0;i<this.events.length;i++){
        var evt = this.events[i];
        if(evt.entityEventType==11){
          count++;
        }
      }
      return count;
    },
    computedPonLosCount: function(){
      var count = 0;
      for(var i=0;i<this.events.length;i++){
        var evt = this.events[i];
        if(evt.entityEventType==23){
          count++;
        }
      }
      return count;
    },
    computedSetup: function () {
      return this.formatDate(this.current.setup);
    },
    tags: function () {
      var ret = [];
      var tgs = this.current.tags.split(" ");
      for (var i = 0; i < tgs.length; i++) {
        if (tgs[i] != "") {
          ret.push({ name: tgs[i] });
        }
      }
      return ret;
    },
  },
  watch: {
    searchClient: function (val) {
      var me = this;
      if (val.length != 3) return;
      var token = localStorage.getItem("token");
      api
        .get("/client/name/" + val, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.clients = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    searchPlan: function (val) {
      var me = this;
      if (val.length != 3) return;
      var token = localStorage.getItem("token");
      api
        .get("/plan/name/" + val, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.plans = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  filters: {
    formatEventType: function(val){
      var ret = "desconhecido";
      if(val==11){
        ret = "Bloqueio";
      }else if(val==12){
        ret = "Desbloqueio";
      }else if(val==13){
        ret = "Cancelamento";
      }else if(val==23){
        ret = "PON";
      }
      return ret;
    }
  }
};
</script>